import { render, staticRenderFns } from "./interakt.vue?vue&type=template&id=90619e22&scoped=true"
import script from "./interakt.vue?vue&type=script&lang=js"
export * from "./interakt.vue?vue&type=script&lang=js"
import style0 from "./interakt.vue?vue&type=style&index=0&id=90619e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90619e22",
  null
  
)

export default component.exports